import { type Common } from './common.js';

export class API {
  common: Common;
  baseEndpoint = `/sftp/servers`;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByOrganizationId(organizationId: string): Promise<string[]> {
    const url = this.common.constructPath(this.baseEndpoint, {
      organizationId,
    });
    const { servers } = await this.common.getJSON(url);
    return servers;
  }
}
